const STATUS_NOT_VERIFIED = 0;
const STATUS_ACTIVE = 1;
const STATUS_INACTIVE = 2;
const STATUS_DELETED = 3;
const STATUS_BLOCKED = 4;

const STATUS_COLOR_ACTIVE = "green";
const STATUS_COLOR_INACTIVE = "black";
const STATUS_COLOR_DELETED = "red";
const STATUS_COLOR_BLOCKED = "blue";
const STATUS_COLOR_DEFAULT = "red";

const GENDER_MALE = 1;
const GENDER_FEMALE = 2;
const GENDER_UNISEX = 3;

export const getStatusText = (status) => {
  switch (status) {
    case STATUS_NOT_VERIFIED:
      return "Not Verified";
    case STATUS_ACTIVE:
      return "Active";
    case STATUS_INACTIVE:
      return "Inactive";
    case STATUS_DELETED:
      return "Blocked";
    case STATUS_BLOCKED:
      return "Rejected";
    default:
      return "";
  }
};

export const getStatusColor = (status) => {
  switch (status) {
    case STATUS_ACTIVE:
      return STATUS_COLOR_ACTIVE;
    case STATUS_INACTIVE:
      return STATUS_COLOR_INACTIVE;
    case STATUS_DELETED:
      return STATUS_COLOR_DELETED;
    case STATUS_BLOCKED:
      return STATUS_COLOR_BLOCKED;
    default:
      return STATUS_COLOR_DEFAULT;
  }
};

export const getGenderText = (gender) => {
  switch (gender) {
    case GENDER_MALE:
      return "Male";
    case GENDER_FEMALE:
      return "Female";
    case GENDER_UNISEX:
      return "Both";
    default:
      return "Unknown";
  }
};
